<template>
  <el-input
    v-model="id"
    :disabled="disabled"
    :readonly="readonly"
    :type="type"
    :rows="rows"
    :size="size"
    :placeholder="placeholder || $t('inputText')"
    :maxlength="maxlength"
    clearable
    :show-word-limit="showWordLimit"
    @focus="onFocus"
    @keyup.native="onKeyUp"
    @blur="id=$event.target.value.trim()"
    @change="onChange"
  >
    <template slot="append">
      <slot name="append" />
    </template>
  </el-input>
</template>

<script>
export default {
  name: 'BjInput',
  props: {
    rows: {
      type: [String, Number],
      default: 2,
    },
    maxlength: {
      type: [String, Number],
      default: 50,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    showWordLimit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: null,
    };
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
    },
  },
  activated() {
    this.id = this.value;
  },
  mounted() {},
  methods: {
    onFocus() {},
    onKeyUp() {
    },
    onBlur() {
      this.$emit('blur');
    },
    onChange(v) {
      this.$emit('change', v);
    },
  },
};
</script>
